import { Box, ImageNew, TextNew } from '@jfs/ui-new'
import { memo, useMemo, FC } from 'react'
import { SvgImage } from '../../../comps/SvgImage'
import { styles } from './styles'

const PhonePay = require('../../../assets/images/all-in-one-qr/phonepe.png')
const GooglePay = require('../../../assets/images/all-in-one-qr/gpay.png')
const Paytm = require('../../../assets/images/all-in-one-qr/paytm.png')

const merchantImage = (image: string) => {
  return (
    <Box {...styles.merchIndividualImage}>
      <ImageNew source={image} height={'15'} width={'15'} />
    </Box>
  )
}

interface UpiDetailInterface {
  vpa: string
  merchantName: string
}

const UpiDetail: FC<UpiDetailInterface> = memo(({ vpa, merchantName }: UpiDetailInterface) => {
  const memoisedPhonePayImage = useMemo(() => merchantImage(PhonePay), [])
  const memoisedGooglePayImage = useMemo(() => merchantImage(GooglePay), [])
  const memoisedPaytmImage = useMemo(() => merchantImage(Paytm), [])
  const memoisedBhimUpiImage = useMemo(() => <SvgImage imageName={'BhimUpi'} />, [])
  const VPA = useMemo(() => vpa, [vpa])

  return (
    <Box {...styles.dataContainer}>
      <Box {...styles.textContainer}>
        <TextNew {...styles.peopeName} title={merchantName ?? ''} />
        <TextNew {...styles.upiName} title={VPA ?? ''} testID={'upiVPA'} />
      </Box>
      <Box {...styles.dottedView} />
      <Box {...styles.UPiImageContainer}>
        <Box>
          <TextNew {...styles.upiTextName('left')} title={'Powered By'} />
          {memoisedBhimUpiImage}
        </Box>
        <Box>
          <TextNew {...styles.upiTextName('right')} title={'Also works with'} />
          <Box {...styles.merchantContainer}>
            {memoisedPhonePayImage}
            {memoisedGooglePayImage}
            {memoisedPaytmImage}
          </Box>
        </Box>
      </Box>
    </Box>
  )
})

export { UpiDetail }
